module.exports = __webpack_public_path__ + "static/Cross-church-web-e6cb68d09722791fc45dd34cec6e426a.png";